import React from "react";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import PaymentMethod from "./PaymentMethod";
import CustomButton from "Components/CustomButton";
const SelectPaymentMethodModal = ({ data, actionHandler, visible, close, customStyle }) => {
  const { t } = useTranslation();
  const handleOk = () => {
    actionHandler("options");
  };

  const handleCancel = () => {
    close();
  };

  const accent = customStyle?.primary?.backgroundColor;

  return (
    <Modal
      title={t("selectPaymentMethod.title")}
      visible={visible}
      wrapClassName="select-method-modal"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <CustomButton type="outline" buttonStyle={customStyle} onClick={handleCancel}>
          {t("selectPaymentMethod.closeButton")}
        </CustomButton>
      }
    >
      <div className="options-container" style={accent ? { "--pm-accent": accent } : undefined}>
        <div className="payment-method-container">
          <div className="card-group">
            <PaymentMethod data={data} actionHandler={actionHandler} selected={() => close()} customStyle={customStyle} />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SelectPaymentMethodModal;
